import React, {
    useContext,
    useEffect,
    useState
} from 'react';

import { GameItem } from '../GameItem/GameItem';
import {
    AsgAppContext,
    AsgDictionaryContext
} from '../../contexts';
import { GameImprovementsTitle } from '../GameImprovementsTitle/GameImprovmentsTitle';
import './RecommendedGames.css';
import { ArrayUtilService } from '../../../../shared/src/services/util/array-util.service';

/**
 * Parent component for show Recommended  in game page
 * @return {JSX.Element}
 * @constructor
 */
export const RecommendedGames = ({
    recommendedOpenStatus,
    changeStatus,
    changeMobilePanelOpenStatus
}) => {
    useEffect(() => {
        if (!recommendedOpenStatus) {
            getCategories();
        }
    }, [recommendedOpenStatus]);

    const [recommendedGames, setRecommendedGames] = useState([]);

    const AsgApp = useContext(AsgAppContext);
    const dictionary = useContext(AsgDictionaryContext);
    const playBtnText = dictionary.translate('playNow');

    const getCategories = () => {
        try {
            let cat = AsgFW.getCategories();
            const firstCategory = cat[0].subCategories[0].instantGamesOrder;
            const recommendedGameIds = ArrayUtilService.getRandomElements(firstCategory, 4);

            let games = [];
            recommendedGameIds.forEach((value) => {
                let temp = AsgFW.getGameById(value);
                if (temp) {
                    games.push(temp);
                }
            });
            setRecommendedGames(games);

        } catch (e) {
            console.error('get categories game failed', e);
        }
    };

    const handleRecommendedOpenStatus = (data) => {
        if (data) {
            AsgApp.GAeventTracking(' recommended for you - ' + (AsgFW.isMobilePamPlatform() ? 'mobile' : 'desktop')
                + ' game page', ' recommended for you - ' + (AsgFW.isMobilePamPlatform() ? 'mobile' : 'desktop')
                + ' game page click', data.name);
        }
        changeStatus(!recommendedOpenStatus);
        if (AsgFW.isMobilePamPlatform()) {
            changeMobilePanelOpenStatus(false);
        }
    };

    return (
        <div className={`recommended-games-component__btn-wrapper ${recommendedOpenStatus ? ' active' : ''}`}>
            <div className="recommended-games-component__btn cta-common"
                onClick={changeStatus}>
            </div>
            {recommendedOpenStatus &&
                <div className="recommended-games-result-wrap">
                    <GameImprovementsTitle title="forYou" />
                    <div className="recommended-games-component__result">
                        {
                            recommendedGames.map((gameItem, key) => (
                                <GameItem
                                    onOpenGame={(game) => {
                                        handleRecommendedOpenStatus(game);
                                    }}
                                    key={key}
                                    data={gameItem}
                                    playBtnText={playBtnText}
                                />
                            ))
                        }
                    </div>
                </div>
            }
        </div>
    );
};
